<template>
  <div class="heatmapArea" :class="device">
    <div class="heatmap_info" ref="heatmapInfo" :class="device">
      <div class="header">
        <i class="icon icon--logo"></i>
        <div class="created">{{ $t('heatmap.created') }}: {{ date }}</div>
      </div>
      <div class="meta">
        <div class="title">{{ paramData.pageData.title }}</div>
        <div class="url">{{ paramData.pageData.linkHost +  paramData.pageData.linkPath}}</div>
      </div>
      <ul class="info-data">
        <li>
          <div class="label" v-html="$t('timezone.dashboard.info')"></div>
          <div class="info-content">
            <span>{{ timezoneName }}</span>
          </div>
        </li>
        <li>
          <div class="label" v-html="$t('heatmap.download.period')"></div>
          <div class="info-content">
            <span v-html="heatmapPeriod"></span>
          </div>
        </li>
        <li>
          <div class="label" v-html="$t('heatmap.download.device')"></div>
          <div class="info-content">
            <span v-html="heatmapDevice"></span>
          </div>
        </li>
        <li>
          <div class="label" v-html="$t('heatmap.download.referrer')"></div>
          <div class="info-content">
            <span v-html="heatmapReferrer"></span>
          </div>
        </li>
        <li>
          <div class="label" v-html="$t('heatmap.download.userType')"></div>
          <div class="info-content">
            <span v-html="heatmapUserType"></span>
          </div>
        </li>
        <li>
          <div class="label" v-html="$t('heatmap.download.data')"></div>
          <div class="info-content">
            <span v-html="heatmapData"></span>
          </div>
        </li>
        <li v-if="this.eventType === 'stream'">
          <div class="label">{{ $t('heatmap.download.pv') }}</div>
          <div class="info-content">
            <span v-html="heatmapPv"></span>
          </div>
        </li>
        <li v-if="heatmapSegments.length">
          <div class="label" v-html="$t('heatmap.download.segments')"></div>
          <ul :class="['info-content', 'item-count--' + heatmapSegments.length]">
            <li v-for="segment of heatmapSegments" v-html="segment" v-bind:key="segment"></li>
          </ul>
        </li>
        <li v-if="this.eventType !== 'stream'">
          <div class="label">{{ $t('heatmap.download.pv') }}</div>
          <div class="info-content">
            <span v-html="heatmapPv"></span>
          </div>
        </li>
      </ul>
    </div>
    <HeatMap
          :mode="'only'"
          :report="paramData.reportView"
          :pageData="pageDataForHeatmap"
          :heatmapParams="paramData"
          :wholeCaptureProcessing="[]"
          />
  </div>
</template>

<script>
import store from '@/store'
import { getPercentage, utcToLocalTimezone } from '@/libs/utils'
import HeatMap from '@/components/journey/heatmap/HeatMap.vue'
import { mapMutations } from 'vuex'
import { changeLocale } from '@/libs/i18n'
export default {
  name: 'HeatmapInfo',
  components: { HeatMap },
  props: [

  ],
  data () {
    return {
      paramData: null,
      domain: null,
      pageDataForHeatmap: null,
      isHeatmapView: true
    }
  },
  beforeCreate () {

  },
  created () {
    this.paramData = JSON.parse(localStorage.getItem('paramData')) || {}

    this.initData()
  },
  computed: {
    device () {
      return this.paramData.device
    },
    timezoneName () {
      return this.domain.timezoneName
    },
    heatmapUrl () {
      return location.protocol + '//' + location.hostname + '/tool/journey?sid=' + this.paramData.pageData.baApply.parentSid
    },
    heatmapPeriod () {
      return this.paramData.start + ' ~ ' + this.paramData.end
    },
    heatmapDevice () {
      return this.$t('common.deviceType.' + this.paramData.device)
    },
    heatmapReferrer () {
      if (this.paramData.refer === null) {
        return this.$t('common.all')
      }
      return this.paramData.refer
    },
    heatmapUserType () {
      const exist = this.paramData.existing
      if (exist === null) {
        return this.$t(`heatmap.journey.viewpercentage.whole`)
      } else if (exist === true) {
        return this.$t(`heatmap.journey.viewpercentage.return`)
      } else {
        return this.$t(`heatmap.journey.viewpercentage.new`)
      }
    },
    eventType () {
      return this.paramData.event
    },
    heatmapType () {
      return this.paramData.typeSource
    },
    heatmapData () {
      const eventType = this.eventType
      if (eventType === 'zoom') {
        return this.$t('heatmap.panel.' + eventType + ['In', 'Out'][this.heatmapType])
      }
      if (eventType === 'swipe') {
        return this.$t('heatmap.panel.' + eventType + ['Vertical', 'Horizontal'][this.heatmapType])
      }
      return this.$t('heatmap.panel.' + eventType)
    },
    heatmapSegments () {
      let segmentTexts = []

      if (this.eventType === 'path') {
        let segmentPath = '<span class="label-segment">' + this.$t('common.path') + ' : </span>'
        let group = this.paramData.core ? 'extreme' : 'median'

        segmentPath += this.$t('reporting.stream.activityStatistics.' + group + 'Group.label')
        segmentTexts.push(segmentPath)
      }
      return segmentTexts
    },
    heatmapPv () {
      let addCommas = function (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return addCommas(this.paramData.currentPv) + ' PV'
    },
    date () {
      const today = utcToLocalTimezone(new Date(), this.domain.timezoneName)
      const pad = function (number) {
        if (number < 10) {
          return '0' + number
        }
        return number
      }
      return today.getFullYear() +
          '-' + pad(today.getMonth() + 1) +
          '-' + pad(today.getDate()) +
          ' ' + pad(today.getHours()) +
          ':' + pad(today.getMinutes()) +
          ':' + pad(today.getSeconds())
    },
    reportPeriod () {
      return store.state.reportPeriod
    },
    deviceData () {
      return this.infoData.device[this.device]
    },
    refererData () {
      if (this.deviceData) {
        return this.deviceData.refer
      }
      return null
    }
  },
  methods: {
    ...mapMutations([
      'setJourneyPeriod',
      'setJourneyOptions'
    ]),
    initData () {
      // this.$i18n.locale = 'ko'

      const lang = this.$route.query.lang || this.paramData.lang || 'ko'
      if (this.$i18n !== lang) {
        changeLocale(this.$i18n, lang)
      }

      const baParamData = this.paramData
      this.pageDataForHeatmap = baParamData.pageData
      this.domain = baParamData.domain
      let parentSid = ''
      parentSid = this.pageDataForHeatmap.baApply.parentSid
      if (parentSid) {
        parentSid = parentSid.substring(1, parentSid.length)
      }
      let subSid = ''
      subSid = this.pageDataForHeatmap.baApply.sid
      if (subSid) {
        subSid = subSid.substring(1, subSid.length)
      }
      this.setJourneyOptions({
        device: baParamData.device,
        exist: baParamData.exist,
        refer: baParamData.refer,
        aiRefererIds: baParamData.aiRefererIds,
        utm: baParamData.utm,
        survey: baParamData.survey || null,
        sid: parentSid,
        subSid: subSid
      })
    },
    getDevicePvPercentage (device) {
      if (!this.infoData.device[device]) {
        return 0
      }
      return getPercentage(this.infoData.device[device].pv, this.infoData.pv)
    },
    getRefererPvPercentage (referer) {
      if (!this.refererData) {
        return 0
      }
      if (referer === 'all') {
        return 100
      }

      const item = this.refererData.find(item => item.refer === referer)

      if (!item) {
        return 0
      }
      return getPercentage(item.pv, this.deviceData.pv)
    }
  }
}
</script>

<style lang="scss" scoped>
.heatmapArea {
  margin: 0;
  position: relative;
  z-index: 0;
  overflow: hidden;
  &.desktop, .tablet {
    width: 700px;
  }
  &.phone {
    width: 438px;
  }
  .heatmap_info {
    background: #ffffff;
    color: #2f2f2f;
    line-height: 1.77;
    padding-bottom: 25px;
    &.desktop, .tablet {
      width: 700px;
    }
    &.phone {
      width: 438px;
    }

    .header {
      position: relative;
      background: #c10a43;
      height: 34px;

      .icon--logo {
        margin: 11px 18px;
        height: 12px;
        width: 78px;
        background-size: auto 100%;
      }

      .created {
        position: absolute;
        top: 9px;
        right: 16px;
        white-space: nowrap;
        font-size: 10px;
        color: #ffffff;
        opacity: 0.8;
        text-align: right;
        width: 200px;
      }
    }

    .meta {
      padding: 17px 27px 27px 27px;

      .title {
        margin-right: 200px;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.43;
      }

      .url {
        font-size: 11px;
        color: #666666;
        line-height: 1.18;
        margin-top: 8px;
      }
    }

    &.phone {
      .meta {
        min-height: 56px;

        .title {
          margin-right: 150px;
        }

        .created {
          margin-top: 10px;
          position: static;
        }
      }
    }

    ul.info-data {
      font-size: 13px;
      border-bottom: 1px solid #ebebeb;
      margin: 2px 27px 0 27px;

      li {
        position: relative;
        border-top: 1px solid #ebebeb;
        line-height: 1.54;

        .label {
          position: absolute;
          top: 0;
          left: 0;
          padding: 3px 10px;
          width: 80px;
          color: #8f8f8f;
        }

        div.info-content {
          padding: 3px 10px 3px 95px;
        }

        ul.info-content {
          padding: 3px 10px 3px 95px;

          li {
            border-top: none;
            position: relative;
            margin-left: 7px;

            &::before {
              position: absolute;
              top: 0;
              left: -7px;
              content:"·";
            }
          }

          &.item-count--1 {
            li {
              margin-left: 0;

              &::before {
                display: none;
              }

              & /deep/ .label-segment {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
